import {
  SET_FILTER_SEARCH,
  SET_SORT_BY_SEARCH,
  SET_USER_DASHBOARD_KEYWORD,
  RESET_USER_DASHBOARD_FILTER,
  SET_USER_DASHBOARD_SORT,
  SET_USER_DASHBOARD_CATEGORY,
  SET_USER_DASHBOARD_STATUS,
  SET_USER_DASHBOARD_PAGE,
  RESET_USER_DASHBOARD_KEYWORD,
} from '../constants';

export const doSetFilterSearch = (status) => {
  return { type: SET_FILTER_SEARCH, data: status };
};

export const doSetSortBySearch = (status) => {
  return { type: SET_SORT_BY_SEARCH, data: status };
};

export const setDashboardKeyword = (text) => (dispatch) => {
  return new Promise((resolve) => {
    resolve(dispatch({ type: SET_USER_DASHBOARD_KEYWORD, data: text }));
  });
};

export const doResetDashboardFilter = () => (dispatch) => {
  return new Promise((resolve) => {
    resolve(dispatch({ type: RESET_USER_DASHBOARD_FILTER }));
  });
};

export const setDashboardSort = (text) => (dispatch) => {
  return new Promise((resolve) => {
    resolve(dispatch({ type: SET_USER_DASHBOARD_SORT, data: text }));
  });
};

export const setDashboardCategory = (text) => (dispatch) => {
  return new Promise((resolve) => {
    resolve(dispatch({ type: SET_USER_DASHBOARD_CATEGORY, data: text }));
  });
};

export const setDashboardStatus = (text) => (dispatch) => {
  return new Promise((resolve) => {
    resolve(dispatch({ type: SET_USER_DASHBOARD_STATUS, data: text }));
  });
};

export const setDashboardPage = (data) => (dispatch) => {
  return new Promise((resolve) => {
    resolve(dispatch({ type: SET_USER_DASHBOARD_PAGE, data }));
  });
}

export const doResetDashboardKeyword = () => {
  return { type: RESET_USER_DASHBOARD_KEYWORD };
};
